import clsx from 'clsx';
import type { CallbackSlot } from './type';

type TimeSlotItemProps = {
  slot: CallbackSlot;
  selected: boolean;
  onSelect: (slot: CallbackSlot) => void;
};

export function TimeSlotItem({ slot, selected, onSelect }: TimeSlotItemProps) {
  return (
    <button
      type="button"
      disabled={!slot.available}
      aria-pressed={selected}
      onClick={() => onSelect(slot)}
      className={clsx(
        'rounded-lg py-3 text-center text-sm font-medium transition-colors duration-200',
        !slot.available && 'bg-brand-muted-light/40 text-gray-light line-through',
        slot.available && 'cursor-pointer',
        slot.available && selected && 'bg-brand-primary text-white',
        slot.available &&
          !selected &&
          'bg-brand-accent/10 text-brand-primary hover:bg-brand-accent/20'
      )}
    >
      {slot.label}
    </button>
  );
}
